<template>
  <div class="component-make">
    <h4 class="text-semibold mb-5">Make</h4>
    <snow-data-table-header
      class="mb-6"
      @add="modal = true"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <snow-data-table :data="integrationList" :columns="makeColumns">
        <template #eventos="{ value }">
          <snow-table-events :events="value" />
        </template>
        <template #url="{ item }">
          <div class="d-flex">
            <snow-button variant="borderless" size="sm" @click="copyUrl(item)">
              <i class="ph ph-link" />
            </snow-button>
            <snow-button variant="borderless" size="sm" @click="openUrl(item)">
              <i class="ph ph-arrow-square-out" />
            </snow-button>
          </div>
        </template>
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <make-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
      @loading="loading = true"
    />
  </div>
</template>
<script>
import MakeModal from "@/components/tools/modals/Make.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  components: {
    MakeModal
  },
  mixins: [IntegrationsMixin],
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      integration: "make",
      modal: false,
      columns: ["Produto", "Descrição", "Eventos", "URL", "Status", ""],
      mobileColumns: ["", ""]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    eventsOptions() {
      let options = [...this.typeEvents];
      options.unshift({ id: "", name: "Todos os eventos" });
      return options;
    },
    makeColumns() {
      return [
        {
          name: "Produto",
          field: "events",
          transform: (value, item) => this.productName(item)
        },
        {
          name: "Descrição",
          field: "description",
          transform: v => this.formatLongText(v)
        },
        {
          name: "Eventos",
          field: "events",
          transform: v => v.map(e => e.event)
        },
        {
          name: "URL",
          field: "url"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          color: v => (v ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          click: () => this.changeStatus(item)
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Não, cancelar",
            action: this.submitDelete
          }
        }
      ];
    },
    dispatch() {
      this.$store.dispatch("integration/getTypeEvents");
      let params = {};

      if (this.search) {
        params = { search: this.search };
      }
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      const data = {
        id: item.id,
        status: !item.status
      };
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(error => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
<style>
.event-button {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 12px;
}
</style>
